// 集中导入 animal-island-ui 的 item 图标资源
// 使用 package.json exports 中的 "./items/*" 路径

// === 喜事选择图标 ===
import item483 from 'animal-island-ui/items/item-483.png'; // 新婚
import item033 from 'animal-island-ui/items/item-033.png'; // 添丁
import item029 from 'animal-island-ui/items/item-029.png'; // 升学
import item485 from 'animal-island-ui/items/item-485.png'; // 祝寿
import item440 from 'animal-island-ui/items/item-440.png'; // 乔迁
import item486 from 'animal-island-ui/items/item-486.png'; // 开张
import item487 from 'animal-island-ui/items/item-487.png'; // 佳节
import item412 from 'animal-island-ui/items/item-412.png'; // 其他

// === 工作台 Tab 图标 ===
import item477 from 'animal-island-ui/items/item-477.png'; // 日历(日程)
import item469 from 'animal-island-ui/items/item-469.png'; // 待办(采购)
import item450 from 'animal-island-ui/items/item-450.png'; // 锦囊妙计
import item461 from 'animal-island-ui/items/item-461.png'; // 账本
import item449 from 'animal-island-ui/items/item-449.png'; // 请帖
import item481 from 'animal-island-ui/items/item-481.png'; // 推荐采购
import item479 from 'animal-island-ui/items/item-479.png'; // 推荐应用

export const EVENT_ICONS: Record<string, string> = {
  wedding: item483,
  baby: item033,
  school: item029,
  birthday: item485,
  move: item440,
  business: item486,
  festival: item487,
  other: item412,
};

export const TAB_ICONS: Record<string, string> = {
  schedule: item477,
  shopping: item469,
  tips: item450,
  ledger: item461,
  invitation: item449,
  recommendShopping: item481,
  recommendApp: item479,
};
